module.exports = __webpack_public_path__ + "img/variable.c1c53b13.png";